export enum AdvancedReportsQueryCategories {
  CLICKS = 'Clicks',
  CONVERSION_WEB = 'ConversionWeb',
  CONVERSION_INBOUNDCALL = 'ConversionInboundCall',
  AD_COST = 'AdCost',
  IMPRESSIONS = 'Impressions',
  REVENUE = 'Revenue',
  SALES = 'Sales',
  OPPORTUNITY = 'Opportunity',
  OPPORTUNITY_VALUE = 'OpportunityValue'
}
